/**
 * Modal that opens when a user clicks "Publish to ArcGIS Online" in the demo.
 *
 * The demo cannot actually publish — that requires an authenticated AGOL
 * account and full pipeline. We show a clean explanation + CTA to full
 * MAPTRIUM. Intentionally styled to look like a real "publish result" screen
 * so it doesn't feel like a dead-end.
 */
export default function AGOLPublishModal({ open, onClose, config }) {
  if (!open) return null;
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="agol-title"
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 px-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg shadow-modal max-w-lg w-full p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start gap-3 mb-4">
          <div
            className="w-10 h-10 rounded-md flex items-center justify-center flex-shrink-0"
            style={{ background: '#1E90FF' }}
            aria-hidden="true"
          >
            <span className="text-white font-bold text-sm">ESRI</span>
          </div>
          <div>
            <h3 id="agol-title" className="text-lg font-semibold text-atlas-ink">
              Publish to ArcGIS Online
            </h3>
            <p className="text-sm text-atlas-muted">
              Available in MAPTRIUM · Not enabled for demo maps
            </p>
          </div>
        </div>

        <div className="bg-atlas-paper rounded-md p-3 mb-4 text-sm">
          <p className="text-atlas-ink mb-2">In MAPTRIUM, one click publishes:</p>
          <ul className="text-atlas-muted space-y-1 ml-1">
            <li>· A Feature Service with all layers on this map</li>
            <li>· A hosted WebMap in your ArcGIS Online org</li>
            <li>· A public share URL + iframe for your GIS Portal</li>
            <li>· Auto-refresh on data changes (daily / weekly / on-demand)</li>
          </ul>
        </div>

        <p className="text-sm text-atlas-muted mb-4">
          Sign into MAPTRIUM, link your AGOL org, and this same map — with your
          real data — publishes in about 15 seconds.
        </p>

        <div className="flex flex-wrap gap-2 justify-end">
          <button type="button" className="btn-secondary" onClick={onClose}>
            Close
          </button>
          <a
            href={`https://maptrium.com/?src=demo_agol&type=${config?.mapType || ''}`}
            target="_blank"
            rel="noopener"
            className="btn-primary no-underline"
          >
            Open MAPTRIUM →
          </a>
        </div>
      </div>
    </div>
  );
}
